import { Link } from "react-router-dom";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import Faq from "../../components/Faqs/Faqs";
import PrivacyHeroIcon from "../../assets/Privacy-Page-Assets/privacy-hero-icon.png";
import {
  LegalCallout,
  LegalContactGrid,
  LegalDocument,
  LegalIconList,
  LegalIntroBanner,
  LegalLead,
  LegalSection,
  LegalText,
} from "../legal/LegalContent";
import "./PrivacyPage.css";

const UPDATED = "22 September 2026";

const PrivacyPage = () => {
  return (
    <div>
      <NavBar />
      <div className="privacy-header">
        <div className="container">
          <div className="privacy-header-body">
            <h1 className="privacy-heading">Privacy Policy</h1>
            <img src={PrivacyHeroIcon} alt="" />
          </div>
        </div>
      </div>

      <div className="legal-page-body">
        <p className="legal-updated">Last updated {UPDATED}</p>
        <LegalDocument>
          <LegalIntroBanner>
            This policy explains how Belsoft Systems Ltd (“Belsoft”, “we”, “us”)
            collects and uses personal data on belsoftsystems.com and related
            company sites. It is written for the Nigeria Data Protection Act
            2023 (NDPA). Product-specific apps such as BelCore and BelPower have
            their own privacy notices as well.
          </LegalIntroBanner>

          <LegalSection title="1. Who we are">
            <LegalLead>
              Belsoft Systems Ltd is a software and digital services company
              registered in Nigeria. Office: Ridds Plaza, Plot 740, Aguwan
              Anaekwe Street, Wuye Suite 046/47, Abuja.
            </LegalLead>
            <LegalContactGrid
              items={[
                {
                  label: "Privacy requests",
                  value: (
                    <a href="mailto:support@belsoftsystems.com">support@belsoftsystems.com</a>
                  ),
                },
                {
                  label: "General enquiries",
                  value: (
                    <a href="mailto:enquiry@belsoftsystems.com">enquiry@belsoftsystems.com</a>
                  ),
                },
              ]}
            />
          </LegalSection>

          <LegalSection title="2. Data we collect">
            <LegalText>
              We collect what you send us and what the site needs to run:
            </LegalText>
            <LegalIconList
              variant="check"
              items={[
                "Contact details from hire-us, join-us, support, academy, and newsletter forms (name, email, phone, company, message).",
                "Job or partnership information you choose to share.",
                "Technical data: IP address, browser, device, pages viewed, and approximate location from your ISP.",
                "Cookies or similar storage for session, analytics, and chat widgets where enabled.",
              ]}
            />
            <LegalIconList
              variant="cross"
              items={[
                "We do not require payment-card numbers on this marketing site.",
                "We do not buy mailing lists to spam you.",
                "We do not sell personal data.",
              ]}
            />
          </LegalSection>

          <LegalSection title="3. Why we use it">
            <LegalText>
              We process data to respond to enquiries, deliver services you
              request (including software projects, academy, and support),
              improve the website, keep it secure, and meet Nigerian legal
              duties. Lawful bases include contract, legitimate interests,
              consent (where you opt in), and legal obligation.
            </LegalText>
            <LegalCallout tone="info">
              If you use a Belsoft product (for example BelCore at app.belcore.io),
              that product’s privacy policy governs workspace and HR data. This
              page covers the company website.
            </LegalCallout>
          </LegalSection>

          <LegalSection title="4. Sharing">
            <LegalIconList
              variant="check"
              items={[
                "Hosting and content tools (including Sanity for the blog).",
                "Email and form processors used to deliver your message to our team.",
                "Analytics providers, if enabled, to understand which pages work.",
                "Professional advisers or authorities when Nigerian law requires it.",
              ]}
            />
            <LegalText>
              Processors may only use your data to provide their service to us.
              We do not share data with unrelated advertisers.
            </LegalText>
          </LegalSection>

          <LegalSection title="5. Cookies">
            <LegalText>
              Essential cookies keep the site working. Optional analytics or
              chat cookies help us improve. You can block non-essential cookies
              in your browser; some features (for example a chat widget) may
              then be limited.
            </LegalText>
          </LegalSection>

          <LegalSection title="6. Retention and security">
            <LegalText>
              Enquiry records are kept while we need them to serve you and for
              a reasonable archive period after, unless a longer legal hold
              applies. We use access controls and encrypted transport. No method
              is perfect — tell support@belsoftsystems.com if you suspect misuse.
            </LegalText>
          </LegalSection>

          <LegalSection title="7. Your NDPA rights">
            <LegalLead>You may request to:</LegalLead>
            <LegalIconList
              variant="check"
              items={[
                "Access a copy of your personal data.",
                "Correct inaccurate data.",
                "Delete data we no longer need.",
                "Object to or restrict certain processing.",
                "Lodge a complaint with the Nigeria Data Protection Commission.",
              ]}
            />
          </LegalSection>

          <LegalSection title="8. Children and international transfers">
            <LegalText>
              This website is aimed at businesses and adults. We do not
              knowingly collect data from children under 18. Some vendors may
              process data outside Nigeria; we use contractual and technical
              safeguards appropriate to the transfer.
            </LegalText>
          </LegalSection>

          <LegalSection title="9. Updates">
            <LegalText>
              We may update this policy. The date above will change. Material
              updates may also be posted on the site.
            </LegalText>
          </LegalSection>

          <LegalSection title="10. Related">
            <LegalText>
              Read our{" "}
              <Link to="/terms-of-service">Terms of Service</Link>. Questions:
              support@belsoftsystems.com.
            </LegalText>
          </LegalSection>
        </LegalDocument>
      </div>

      <Faq />
      <Footer />
    </div>
  );
};

export default PrivacyPage;
